import React, { useEffect, useState } from "react";
import { Box, Typography, Card, CardContent, Container } from "@mui/material";

const testimonials = [
  {
    name: "Иван Петров",
    position: "CEO",
    text: "Използването на препаратите е лесно и безопасно. Соларните панели са винаги чисти и ефективни.",
    logo: "/images/logos/sunterra.Jpg",
  },
  {
    name: "Мария Георгиева",
    position: "Project Manager",
    text: "Професионален подход и реални резултати. Препаратите им наистина работят.",
    logo: "/images/logos/astronenergy.png",
  },
  {
    name: "Петър Димитров",
    position: "Operations",
    text: "Силно препоръчваме! Почистването на соларни панели с техните препарати е безопасно и ефективно.",
    logo: "/images/logos/sunotec.png",
  },
];

export default function TestimonialsCarousel() {
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      // fade-out
      setFade(false);

      // след 0.5s (fade-out) сменяме slide
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % testimonials.length);
        setFade(true); // fade-in
      }, 500);
    }, 3000); // ✅ остава 3 секунди за четене

    return () => clearTimeout(timeout);
  }, [current]);

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: "#f5f8ff",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          mb={6}
          sx={{ color: "#2f4f7f" }}
        >
          Какво казват нашите клиенти
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
            height: 260, // фиксирана височина за плавно fade
          }}
        >
          {testimonials.map((item, index) => (
            <Card
              key={index}
              sx={{
                position: "absolute",
                opacity: index === current && fade ? 1 : 0,
                transform: index === current ? "scale(1)" : "scale(0.95)",
                transition: "opacity 0.8s ease, transform 0.8s ease",
                p: 4,
                textAlign: "center",
                boxShadow: 3,
                borderRadius: 2,
                borderTop: "4px solid #f2d35c",
                maxWidth: 400,
                width: "100%",
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  component="img"
                  src={item.logo}
                  alt={item.position}
                  sx={{ height: 40, width: "auto" }}
                />
                <Typography
                  variant="body1"
                  textAlign="center"
                  sx={{ color: "#2f4f7f", fontStyle: "italic" }}
                >
                  "{item.text}"
                </Typography>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ color: "#2f4f7f" }}
                >
                  {item.name}
                </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  {item.position}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>

        {/* Dots navigation */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 10,
            gap: 1.5,
          }}
        >
          {testimonials.map((_, idx) => (
            <Box
              key={idx}
              onClick={() => setCurrent(idx)}
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: current === idx ? "#2f4f7f" : "#f2d35c",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
}
